import { render } from "./EditMemo.vue?vue&type=template&id=8d18cff0"
import script from "./EditMemo.vue?vue&type=script&lang=js"
export * from "./EditMemo.vue?vue&type=script&lang=js"

import "./EditMemo.vue?vue&type=style&index=0&id=8d18cff0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__